import { useEffect } from 'react'

// To-Do: create actions with ctrl-key and shift-key
type event = (e: KeyboardEvent) => void | boolean

const useKeyDown = (events: { [ key: string ]: event }, dependencies: any[] = []) => {
  useEffect(() => {
    const keyDown = (e: KeyboardEvent) => {
      if (!(e.code in events)) return

      if (typeof events[e.code] === 'function') {
        const res = events[e.code](e)
        if (res === true) {
          e.preventDefault()
        }
      }
    }
    document.addEventListener('keydown', keyDown)
    return () => document.removeEventListener('keydown', keyDown)
  }, dependencies)   // eslint-disable-line react-hooks/exhaustive-deps
}

export default useKeyDown